











import { Component, Vue } from 'vue-property-decorator'
import { ITableHeaderColumn } from '@/types/interfaces/table-header-column'
import { permissionService } from '@/services/permission.service'
import ViewBackofficeAutorizacaoBase from './backoffice-autorizacao-base.vue'

@Component({
  components: { ViewBackofficeAutorizacaoBase },
})
export default class ViewBackofficeAutorizacao extends Vue {
  $refs!: {
    autorizacaoBase: ViewBackofficeAutorizacaoBase
  }

  readyState = false

  headers: ITableHeaderColumn[] = []

  async init() {
    this.getTableHeaders()
    await this.$refs.autorizacaoBase.init()
    this.readyState = true
  }

  setColumnHeaders() {
    this.headers.push({ text: '', value: 'expand', sortable: false, active: true })
    this.headers.push({ text: 'Paciente', value: 'pacienteNome', sortable: false, active: true })
    this.headers.push({ text: 'Médico', value: 'medicoNome', sortable: false, active: true })
    this.headers.push({ text: 'Convênio', value: 'convenioNome', sortable: false, active: true })
    this.headers.push({ text: 'Item particular', value: 'temItemParticular', sortable: false, active: true })
    this.headers.push({ text: 'Caráter', value: 'carater', sortable: false, active: true })
    this.headers.push({ text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false, active: true })
    this.headers.push({ text: 'Situação', value: 'situacao', sortable: false, active: true })
    this.headers.push({ text: 'Parcial c/ aceite médico', value: 'autorizacaoParcialAceitaPeloMedico', sortable: false, active: true })
    this.headers.push({ text: 'RA', value: 'ra', sortable: false, active: true, align: 'center' })

    if (permissionService.hasPermission('agendamento.backoffice.fidelizacao.listar')) {
      this.headers.push({ text: 'Fidelização', value: 'statusFidelizacao', sortable: false, active: true })
    }

    this.headers.push({ text: 'Status da cirurgia', value: 'statusCirurgia', sortable: false, active: true })
    this.headers.push({ text: 'SLA', value: 'statusSla', sortable: false, active: true })
    this.headers.push({ text: 'Data de validade', value: 'autorizacaoValidade', align: 'center', sortable: false, active: true })
    this.headers.push({ text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' })
    this.headers.push({ text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true })
    this.headers.push({ text: '', value: 'more', sortable: false, active: true })
  }

  getTableHeaders() {
    this.setColumnHeaders()
    const headers = localStorage.getItem('backoffice-autorizacao-table-headers')

    if (!headers) return

    // Preserva a configuração salva do usuário, mas insere colunas novas do código
    // (ex: 'autorizacaoParcialAceitaPeloMedico') que ainda não existem na configuração
    // salva — sem isso, colunas adicionadas em novas versões nunca apareceriam para
    // usuários com preferências já persistidas.
    const headersSalvos: ITableHeaderColumn[] = JSON.parse(headers)

    this.headers.forEach((header, index) => {
      if (!headersSalvos.some(salvo => salvo.value === header.value)) {
        headersSalvos.splice(index, 0, header)
      }
    })

    this.headers = headersSalvos
  }

  async mounted() {
    await this.init()
  }
}
